import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import moment from 'moment'
import Axios from 'axios'

Vue.config.productionTip = false

Vue.filter('capAt100', function(text) {
  if (text.length > 103) {
    return text.substr(0, 100).trim() + "..."
  }
  return text
})

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm')
  }
})

Vue.prototype.$http = Axios
Vue.prototype.$http.defaults.baseURL = process.env.VUE_APP_BACK_URL

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = `Token ${token}`
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
